import React from 'react';
import { connect } from 'react-redux';
import * as Actions from '../services/actions';
import { navigate } from '../services/navigation';

function SearchBox({ search, settings, setSearchTerm }) {
	const s = settings;
	let searchInput = null;

	const click = e => {
		e.preventDefault();
		e.stopPropagation();
		navigate(search, { term: searchInput.value, pageIndex: 0 });
	};

	const keyDown = e => {
		if (e.keyCode === 13) {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	const keyUp = e => {
		if (e.keyCode === 13) {
			e.preventDefault();
			e.stopPropagation();
			navigate(search, { term: searchInput.value, pageIndex: 0 });
		}
	};

	const setSearchInput = input => {
		searchInput = input;
		if (input && search && search.term) {
			input.value = search.term;
		}
		else if (input && search) {
			input.value = '';
		}
	};

	return (
		<div className="filter filter__input filter__input-search search__input">
			<label htmlFor="search-box" className="search__label visuallyhidden" aria-hidden="true">Keywords</label>
			<input className="filter__element" onKeyDown={keyDown} onKeyUp={keyUp} type="text" placeholder='Enter keywords' id="search-box" ref={setSearchInput} />	
			<button id="twiSearch" onClick={click} className="site-search__button"></button>
		</div>				
	);
}

const mapDispatchToProps = dispatch => ({
	setSearchTerm: (term) => {
		dispatch(Actions.setSearchTerm(term));
	} 
});

export default connect(null, mapDispatchToProps)(SearchBox);
